import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex } from 'src/kit';

const Message = styled.span`
  font-size: 12px;
  margin-left: 10px;
`;

const ErrorBody = ({ children, msg }) => (
  <Flex alignItems="center">
    {children}
    <Message>{msg}</Message>
  </Flex>
);

ErrorBody.propTypes = {
  msg: PropTypes.string.isRequired,
  children: PropTypes.node
};

export default ErrorBody;
